import React from 'react';
import AddEditRoleForm from 'ui-component/AddEditRoleForm';

function EditRole() {
  return (
    <div>
      <AddEditRoleForm title="Edit Role" />
    </div>
  );
}

export default EditRole;
